import { createService } from "@/services/serviceFactory";
import type { AccessCountByDay, RegistrationCountByDay } from "./analytics.interfaces";
import { AnalyticsApiService } from "./analytics.api";
import { AnalyticsMockService } from "./analytics.mock";

export interface IAnalyticsService {
  getAccessesByDay(from: string, to: string): Promise<AccessCountByDay[]>;
  getRegistrationsByDay(from: string, to: string): Promise<RegistrationCountByDay[]>;
}

export const createAnalyticsService = (): IAnalyticsService => {
  return createService<IAnalyticsService>(
    "analytics",
    AnalyticsApiService,
    AnalyticsMockService
  );
};
